import _slicedToArray from "/Users/challen/code/react-google-login/example/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/challen/code/react-google-login/example/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/challen/code/react-google-login/example/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useRef, useEffect, useCallback, useContext, createContext } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var Event =
/** @class */
function () {
  function Event(type, target) {
    this.target = target;
    this.type = type;
  }

  return Event;
}();

var ErrorEvent =
/** @class */
function (_super) {
  __extends(ErrorEvent, _super);

  function ErrorEvent(error, target) {
    var _this = _super.call(this, 'error', target) || this;

    _this.message = error.message;
    _this.error = error;
    return _this;
  }

  return ErrorEvent;
}(Event);

var CloseEvent =
/** @class */
function (_super) {
  __extends(CloseEvent, _super);

  function CloseEvent(code, reason, target) {
    if (code === void 0) {
      code = 1000;
    }

    if (reason === void 0) {
      reason = '';
    }

    var _this = _super.call(this, 'close', target) || this;

    _this.wasClean = true;
    _this.code = code;
    _this.reason = reason;
    return _this;
  }

  return CloseEvent;
}(Event);
/*!
 * Reconnecting WebSocket
 * by Pedro Ladaria <pedro.ladaria@gmail.com>
 * https://github.com/pladaria/reconnecting-websocket
 * License MIT
 */


var getGlobalWebSocket = function getGlobalWebSocket() {
  if (typeof WebSocket !== 'undefined') {
    // @ts-ignore
    return WebSocket;
  }
};
/**
 * Returns true if given argument looks like a WebSocket class
 */


var isWebSocket = function isWebSocket(w) {
  return typeof w !== 'undefined' && !!w && w.CLOSING === 2;
};

var DEFAULT = {
  maxReconnectionDelay: 10000,
  minReconnectionDelay: 1000 + Math.random() * 4000,
  minUptime: 5000,
  reconnectionDelayGrowFactor: 1.3,
  connectionTimeout: 4000,
  maxRetries: Infinity,
  maxEnqueuedMessages: Infinity,
  startClosed: false,
  debug: false
};

var ReconnectingWebSocket =
/** @class */
function () {
  function ReconnectingWebSocket(url, protocols, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    this._listeners = {
      error: [],
      message: [],
      open: [],
      close: []
    };
    this._retryCount = -1;
    this._shouldReconnect = true;
    this._connectLock = false;
    this._binaryType = 'blob';
    this._closeCalled = false;
    this._messageQueue = [];
    /**
     * An event listener to be called when the WebSocket connection's readyState changes to CLOSED
     */

    this.onclose = null;
    /**
     * An event listener to be called when an error occurs
     */

    this.onerror = null;
    /**
     * An event listener to be called when a message is received from the server
     */

    this.onmessage = null;
    /**
     * An event listener to be called when the WebSocket connection's readyState changes to OPEN;
     * this indicates that the connection is ready to send and receive data
     */

    this.onopen = null;

    this._handleOpen = function (event) {
      _this._debug('open event');

      var _a = _this._options.minUptime,
          minUptime = _a === void 0 ? DEFAULT.minUptime : _a;
      clearTimeout(_this._connectTimeout);
      _this._uptimeTimeout = setTimeout(function () {
        return _this._acceptOpen();
      }, minUptime);
      _this._ws.binaryType = _this._binaryType; // send enqueued messages (messages sent before websocket open event)

      _this._messageQueue.forEach(function (message) {
        return _this._ws.send(message);
      });

      _this._messageQueue = [];

      if (_this.onopen) {
        _this.onopen(event);
      }

      _this._listeners.open.forEach(function (listener) {
        return _this._callEventListener(event, listener);
      });
    };

    this._handleMessage = function (event) {
      _this._debug('message event');

      if (_this.onmessage) {
        _this.onmessage(event);
      }

      _this._listeners.message.forEach(function (listener) {
        return _this._callEventListener(event, listener);
      });
    };

    this._handleError = function (event) {
      _this._debug('error event', event.message);

      _this._disconnect(undefined, event.message === 'TIMEOUT' ? 'timeout' : undefined);

      if (_this.onerror) {
        _this.onerror(event);
      }

      _this._debug('exec error listeners');

      _this._listeners.error.forEach(function (listener) {
        return _this._callEventListener(event, listener);
      });

      _this._connect();
    };

    this._handleClose = function (event) {
      _this._debug('close event');

      _this._clearTimeouts();

      if (_this._shouldReconnect) {
        _this._connect();
      }

      if (_this.onclose) {
        _this.onclose(event);
      }

      _this._listeners.close.forEach(function (listener) {
        return _this._callEventListener(event, listener);
      });
    };

    this._url = url;
    this._protocols = protocols;
    this._options = options;

    if (this._options.startClosed) {
      this._shouldReconnect = false;
    }

    this._connect();
  }

  Object.defineProperty(ReconnectingWebSocket, "CONNECTING", {
    get: function get() {
      return 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket, "OPEN", {
    get: function get() {
      return 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket, "CLOSING", {
    get: function get() {
      return 2;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket, "CLOSED", {
    get: function get() {
      return 3;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "CONNECTING", {
    get: function get() {
      return ReconnectingWebSocket.CONNECTING;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "OPEN", {
    get: function get() {
      return ReconnectingWebSocket.OPEN;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSING", {
    get: function get() {
      return ReconnectingWebSocket.CLOSING;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "CLOSED", {
    get: function get() {
      return ReconnectingWebSocket.CLOSED;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "binaryType", {
    get: function get() {
      return this._ws ? this._ws.binaryType : this._binaryType;
    },
    set: function set(value) {
      this._binaryType = value;

      if (this._ws) {
        this._ws.binaryType = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "retryCount", {
    /**
     * Returns the number or connection retries
     */
    get: function get() {
      return Math.max(this._retryCount, 0);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "bufferedAmount", {
    /**
     * The number of bytes of data that have been queued using calls to send() but not yet
     * transmitted to the network. This value resets to zero once all queued data has been sent.
     * This value does not reset to zero when the connection is closed; if you keep calling send(),
     * this will continue to climb. Read only
     */
    get: function get() {
      var bytes = this._messageQueue.reduce(function (acc, message) {
        if (typeof message === 'string') {
          acc += message.length; // not byte size
        } else if (message instanceof Blob) {
          acc += message.size;
        } else {
          acc += message.byteLength;
        }

        return acc;
      }, 0);

      return bytes + (this._ws ? this._ws.bufferedAmount : 0);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "extensions", {
    /**
     * The extensions selected by the server. This is currently only the empty string or a list of
     * extensions as negotiated by the connection
     */
    get: function get() {
      return this._ws ? this._ws.extensions : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "protocol", {
    /**
     * A string indicating the name of the sub-protocol the server selected;
     * this will be one of the strings specified in the protocols parameter when creating the
     * WebSocket object
     */
    get: function get() {
      return this._ws ? this._ws.protocol : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "readyState", {
    /**
     * The current state of the connection; this is one of the Ready state constants
     */
    get: function get() {
      if (this._ws) {
        return this._ws.readyState;
      }

      return this._options.startClosed ? ReconnectingWebSocket.CLOSED : ReconnectingWebSocket.CONNECTING;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ReconnectingWebSocket.prototype, "url", {
    /**
     * The URL as resolved by the constructor
     */
    get: function get() {
      return this._ws ? this._ws.url : '';
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Closes the WebSocket connection or connection attempt, if any. If the connection is already
   * CLOSED, this method does nothing
   */

  ReconnectingWebSocket.prototype.close = function (code, reason) {
    if (code === void 0) {
      code = 1000;
    }

    this._closeCalled = true;
    this._shouldReconnect = false;

    this._clearTimeouts();

    if (!this._ws) {
      this._debug('close enqueued: no ws instance');

      return;
    }

    if (this._ws.readyState === this.CLOSED) {
      this._debug('close: already closed');

      return;
    }

    this._ws.close(code, reason);
  };
  /**
   * Closes the WebSocket connection or connection attempt and connects again.
   * Resets retry counter;
   */


  ReconnectingWebSocket.prototype.reconnect = function (code, reason) {
    this._shouldReconnect = true;
    this._closeCalled = false;
    this._retryCount = -1;

    if (!this._ws || this._ws.readyState === this.CLOSED) {
      this._connect();
    } else {
      this._disconnect(code, reason);

      this._connect();
    }
  };
  /**
   * Enqueue specified data to be transmitted to the server over the WebSocket connection
   */


  ReconnectingWebSocket.prototype.send = function (data) {
    if (this._ws && this._ws.readyState === this.OPEN) {
      this._debug('send', data);

      this._ws.send(data);
    } else {
      var _a = this._options.maxEnqueuedMessages,
          maxEnqueuedMessages = _a === void 0 ? DEFAULT.maxEnqueuedMessages : _a;

      if (this._messageQueue.length < maxEnqueuedMessages) {
        this._debug('enqueue', data);

        this._messageQueue.push(data);
      }
    }
  };
  /**
   * Register an event handler of a specific event type
   */


  ReconnectingWebSocket.prototype.addEventListener = function (type, listener) {
    if (this._listeners[type]) {
      // @ts-ignore
      this._listeners[type].push(listener);
    }
  };

  ReconnectingWebSocket.prototype.dispatchEvent = function (event) {
    var e_1, _a;

    var listeners = this._listeners[event.type];

    if (listeners) {
      try {
        for (var listeners_1 = __values(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
          var listener = listeners_1_1.value;

          this._callEventListener(event, listener);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    return true;
  };
  /**
   * Removes an event listener
   */


  ReconnectingWebSocket.prototype.removeEventListener = function (type, listener) {
    if (this._listeners[type]) {
      // @ts-ignore
      this._listeners[type] = this._listeners[type].filter(function (l) {
        return l !== listener;
      });
    }
  };

  ReconnectingWebSocket.prototype._debug = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (this._options.debug) {
      // not using spread because compiled version uses Symbols
      // tslint:disable-next-line
      console.log.apply(console, __spread(['RWS>'], args));
    }
  };

  ReconnectingWebSocket.prototype._getNextDelay = function () {
    var _a = this._options,
        _b = _a.reconnectionDelayGrowFactor,
        reconnectionDelayGrowFactor = _b === void 0 ? DEFAULT.reconnectionDelayGrowFactor : _b,
        _c = _a.minReconnectionDelay,
        minReconnectionDelay = _c === void 0 ? DEFAULT.minReconnectionDelay : _c,
        _d = _a.maxReconnectionDelay,
        maxReconnectionDelay = _d === void 0 ? DEFAULT.maxReconnectionDelay : _d;
    var delay = 0;

    if (this._retryCount > 0) {
      delay = minReconnectionDelay * Math.pow(reconnectionDelayGrowFactor, this._retryCount - 1);

      if (delay > maxReconnectionDelay) {
        delay = maxReconnectionDelay;
      }
    }

    this._debug('next delay', delay);

    return delay;
  };

  ReconnectingWebSocket.prototype._wait = function () {
    var _this = this;

    return new Promise(function (resolve) {
      setTimeout(resolve, _this._getNextDelay());
    });
  };

  ReconnectingWebSocket.prototype._getNextUrl = function (urlProvider) {
    if (typeof urlProvider === 'string') {
      return Promise.resolve(urlProvider);
    }

    if (typeof urlProvider === 'function') {
      var url = urlProvider();

      if (typeof url === 'string') {
        return Promise.resolve(url);
      }

      if (!!url.then) {
        return url;
      }
    }

    throw Error('Invalid URL');
  };

  ReconnectingWebSocket.prototype._connect = function () {
    var _this = this;

    if (this._connectLock || !this._shouldReconnect) {
      return;
    }

    this._connectLock = true;
    var _a = this._options,
        _b = _a.maxRetries,
        maxRetries = _b === void 0 ? DEFAULT.maxRetries : _b,
        _c = _a.connectionTimeout,
        connectionTimeout = _c === void 0 ? DEFAULT.connectionTimeout : _c,
        _d = _a.WebSocket,
        WebSocket = _d === void 0 ? getGlobalWebSocket() : _d;

    if (this._retryCount >= maxRetries) {
      this._debug('max retries reached', this._retryCount, '>=', maxRetries);

      return;
    }

    this._retryCount++;

    this._debug('connect', this._retryCount);

    this._removeListeners();

    if (!isWebSocket(WebSocket)) {
      throw Error('No valid WebSocket class provided');
    }

    this._wait().then(function () {
      return _this._getNextUrl(_this._url);
    }).then(function (url) {
      // close could be called before creating the ws
      if (_this._closeCalled) {
        return;
      }

      _this._debug('connect', {
        url: url,
        protocols: _this._protocols
      });

      _this._ws = _this._protocols ? new WebSocket(url, _this._protocols) : new WebSocket(url);
      _this._ws.binaryType = _this._binaryType;
      _this._connectLock = false;

      _this._addListeners();

      _this._connectTimeout = setTimeout(function () {
        return _this._handleTimeout();
      }, connectionTimeout);
    });
  };

  ReconnectingWebSocket.prototype._handleTimeout = function () {
    this._debug('timeout event');

    this._handleError(new ErrorEvent(Error('TIMEOUT'), this));
  };

  ReconnectingWebSocket.prototype._disconnect = function (code, reason) {
    if (code === void 0) {
      code = 1000;
    }

    this._clearTimeouts();

    if (!this._ws) {
      return;
    }

    this._removeListeners();

    try {
      this._ws.close(code, reason);

      this._handleClose(new CloseEvent(code, reason, this));
    } catch (error) {// ignore
    }
  };

  ReconnectingWebSocket.prototype._acceptOpen = function () {
    this._debug('accept open');

    this._retryCount = 0;
  };

  ReconnectingWebSocket.prototype._callEventListener = function (event, listener) {
    if ('handleEvent' in listener) {
      // @ts-ignore
      listener.handleEvent(event);
    } else {
      // @ts-ignore
      listener(event);
    }
  };

  ReconnectingWebSocket.prototype._removeListeners = function () {
    if (!this._ws) {
      return;
    }

    this._debug('removeListeners');

    this._ws.removeEventListener('open', this._handleOpen);

    this._ws.removeEventListener('close', this._handleClose);

    this._ws.removeEventListener('message', this._handleMessage); // @ts-ignore


    this._ws.removeEventListener('error', this._handleError);
  };

  ReconnectingWebSocket.prototype._addListeners = function () {
    if (!this._ws) {
      return;
    }

    this._debug('addListeners');

    this._ws.addEventListener('open', this._handleOpen);

    this._ws.addEventListener('close', this._handleClose);

    this._ws.addEventListener('message', this._handleMessage); // @ts-ignore


    this._ws.addEventListener('error', this._handleError);
  };

  ReconnectingWebSocket.prototype._clearTimeouts = function () {
    clearTimeout(this._connectTimeout);
    clearTimeout(this._uptimeTimeout);
  };

  return ReconnectingWebSocket;
}();

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var errors = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics2 = function extendStatics(d, b) {
      _extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          if (b.hasOwnProperty(p)) d[p] = b[p];
        }
      };

      return _extendStatics2(d, b);
    };

    return function (d, b) {
      _extendStatics2(d, b);

      function __() {
        this.constructor = d;
      }

      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var ValidationError =
  /** @class */
  function (_super) {
    __extends(ValidationError, _super);

    function ValidationError(message, key) {
      var _this = _super.call(this, key ? message + " in " + key : message) || this;

      _this.key = key;
      _this.name = 'ValidationError';
      Object.setPrototypeOf(_this, ValidationError.prototype);
      return _this;
    }

    return ValidationError;
  }(Error);

  exports.ValidationError = ValidationError;
});
unwrapExports(errors);
var errors_1 = errors.ValidationError;
var contract = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Contract() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
      enforce: function enforce(f) {
        return function () {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          if (args.length < argTypes.length) throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);

          for (var i = 0; i < argTypes.length; i++) {
            argTypes[i].check(args[i]);
          }

          return returnType.check(f.apply(void 0, args));
        };
      }
    };
  }

  exports.Contract = Contract;
});
unwrapExports(contract);
var contract_1 = contract.Contract;
var asynccontract = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function AsyncContract() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    var lastIndex = runtypes.length - 1;
    var argTypes = runtypes.slice(0, lastIndex);
    var returnType = runtypes[lastIndex];
    return {
      enforce: function enforce(f) {
        return function () {
          var args = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }

          if (args.length < argTypes.length) throw new errors.ValidationError("Expected " + argTypes.length + " arguments but only received " + args.length);

          for (var i = 0; i < argTypes.length; i++) {
            argTypes[i].check(args[i]);
          }

          var returnedPromise = f.apply(void 0, args);
          if (!(returnedPromise instanceof Promise)) throw new errors.ValidationError("Expected function to return a promise, but instead got " + returnedPromise);
          return returnedPromise.then(returnType.check);
        };
      }
    };
  }

  exports.AsyncContract = AsyncContract;
});
unwrapExports(asynccontract);
var asynccontract_1 = asynccontract.AsyncContract;
var match_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function match() {
    var cases = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      cases[_i] = arguments[_i];
    }

    return function (x) {
      for (var _i = 0, cases_1 = cases; _i < cases_1.length; _i++) {
        var _a = cases_1[_i],
            T = _a[0],
            f = _a[1];
        if (T.guard(x)) return f(x);
      }

      throw new Error('No alternatives were matched');
    };
  }

  exports.match = match;
});
unwrapExports(match_1);
var match_2 = match_1.match;
var show_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var show = function show(needsParens, circular) {
    return function (refl) {
      var parenthesize = function parenthesize(s) {
        return needsParens ? "(" + s + ")" : s;
      };

      if (circular.has(refl)) {
        return parenthesize("CIRCULAR " + refl.tag);
      }

      circular.add(refl);

      try {
        switch (refl.tag) {
          // Primitive types
          case 'unknown':
          case 'never':
          case 'void':
          case 'boolean':
          case 'number':
          case 'string':
          case 'symbol':
          case 'function':
            return refl.tag;
          // Complex types

          case 'literal':
            {
              var value = refl.value;
              return typeof value === 'string' ? "\"" + value + "\"" : String(value);
            }

          case 'array':
            return "" + readonlyTag(refl) + show(true, circular)(refl.element) + "[]";

          case 'dictionary':
            return "{ [_: " + refl.key + "]: " + show(false, circular)(refl.value) + " }";

          case 'record':
            {
              var keys = Object.keys(refl.fields);
              return keys.length ? "{ " + keys.map(function (k) {
                return "" + readonlyTag(refl) + k + partialTag(refl) + ": " + show(false, circular)(refl.fields[k]) + ";";
              }).join(' ') + " }" : '{}';
            }

          case 'tuple':
            return "[" + refl.components.map(show(false, circular)).join(', ') + "]";

          case 'union':
            return parenthesize("" + refl.alternatives.map(show(true, circular)).join(' | '));

          case 'intersect':
            return parenthesize("" + refl.intersectees.map(show(true, circular)).join(' & '));

          case 'constraint':
            return refl.name || show(needsParens, circular)(refl.underlying);

          case 'instanceof':
            var name_1 = refl.ctor.name;
            return "InstanceOf<" + name_1 + ">";

          case 'brand':
            return show(needsParens, circular)(refl.entity);
        }
      } finally {
        circular.delete(refl);
      }

      throw Error('impossible');
    };
  };

  exports.default = show(false, new Set());

  function partialTag(_a) {
    var isPartial = _a.isPartial;
    return isPartial ? '?' : '';
  }

  function readonlyTag(_a) {
    var isReadonly = _a.isReadonly;
    return isReadonly ? 'readonly ' : '';
  }
});
unwrapExports(show_1);
var runtype = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function create(validate, A) {
    A.check = check;
    A.assert = check;

    A._innerValidate = function (value, visited) {
      if (visited.has(value, A)) return {
        success: true,
        value: value
      };
      return validate(value, visited);
    };

    A.validate = function (value) {
      return A._innerValidate(value, VisitedState());
    };

    A.guard = guard;
    A.Or = Or;
    A.And = And;
    A.withConstraint = withConstraint;
    A.withGuard = withGuard;
    A.withBrand = withBrand;
    A.reflect = A;

    A.toString = function () {
      return "Runtype<" + show_1.default(A) + ">";
    };

    return A;

    function check(x) {
      var validated = A.validate(x);

      if (validated.success) {
        return validated.value;
      }

      throw new errors.ValidationError(validated.message, validated.key);
    }

    function guard(x) {
      return A.validate(x).success;
    }

    function Or(B) {
      return lib.Union(A, B);
    }

    function And(B) {
      return lib.Intersect(A, B);
    }

    function withConstraint(constraint, options) {
      return lib.Constraint(A, constraint, options);
    }

    function withGuard(guard, options) {
      return lib.Constraint(A, guard, options);
    }

    function withBrand(B) {
      return lib.Brand(B, A);
    }
  }

  exports.create = create;

  function innerValidate(targetType, value, visited) {
    return targetType._innerValidate(value, visited);
  }

  exports.innerValidate = innerValidate;

  function VisitedState() {
    var members = new WeakMap();

    var add = function add(candidate, type) {
      if (candidate === null || !(typeof candidate === 'object')) return;
      var typeSet = members.get(candidate);
      members.set(candidate, typeSet ? typeSet.set(type, true) : new WeakMap().set(type, true));
    };

    var has = function has(candidate, type) {
      var typeSet = members.get(candidate);
      var value = typeSet && typeSet.get(type) || false;
      add(candidate, type);
      return value;
    };

    return {
      has: has
    };
  }
});
unwrapExports(runtype);
var runtype_1 = runtype.create;
var runtype_2 = runtype.innerValidate;
var unknown = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates anything, but provides no new type information about it.
   */

  exports.Unknown = runtype.create(function (value) {
    return {
      success: true,
      value: value
    };
  }, {
    tag: 'unknown'
  });
});
unwrapExports(unknown);
var unknown_1 = unknown.Unknown;
var never = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates nothing (unknown fails).
   */

  exports.Never = runtype.create(function (value) {
    return {
      success: false,
      message: "Expected nothing, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'never'
  });
});
unwrapExports(never);
var never_1 = never.Never;

var _void = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Void is an alias for Unknown
   *
   * @deprecated Please use Unknown instead
   */

  exports.Void = unknown.Unknown;
});

unwrapExports(_void);
var _void_1 = _void.Void;
var literal_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Be aware of an Array of Symbols `[Symbol()]` which would throw "TypeError: Cannot convert a Symbol value to a string"
   */

  function literal(value) {
    return Array.isArray(value) ? String(value.map(String)) : String(value);
  }
  /**
   * Construct a runtype for a type literal.
   */


  function Literal(valueBase) {
    return runtype.create(function (value) {
      return value === valueBase ? {
        success: true,
        value: value
      } : {
        success: false,
        message: "Expected literal '" + literal(valueBase) + "', but was '" + literal(value) + "'"
      };
    }, {
      tag: 'literal',
      value: valueBase
    });
  }

  exports.Literal = Literal;
  /**
   * An alias for Literal(undefined).
   */

  exports.Undefined = Literal(undefined);
  /**
   * An alias for Literal(null).
   */

  exports.Null = Literal(null);
});
unwrapExports(literal_1);
var literal_2 = literal_1.Literal;
var literal_3 = literal_1.Undefined;
var literal_4 = literal_1.Null;
var boolean_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a boolean.
   */

  exports.Boolean = runtype.create(function (value) {
    return typeof value === 'boolean' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected boolean, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'boolean'
  });
});
unwrapExports(boolean_1);
var boolean_2 = boolean_1.Boolean;
var number = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a number.
   */

  exports.Number = runtype.create(function (value) {
    return typeof value === 'number' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected number, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'number'
  });
});
unwrapExports(number);
var number_1 = number.Number;
var string = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a string.
   */

  exports.String = runtype.create(function (value) {
    return typeof value === 'string' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected string, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'string'
  });
});
unwrapExports(string);
var string_1 = string.String;
var symbol = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Validates that a value is a symbol.
   */

  var Sym = runtype.create(function (value) {
    return typeof value === 'symbol' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected symbol, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'symbol'
  });
  exports.Symbol = Sym;
});
unwrapExports(symbol);
var symbol_1 = symbol.Symbol;
var array = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct an array runtype from a runtype for its elements.
   */

  function InternalArr(element, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (xs, visited) {
      if (!Array.isArray(xs)) {
        return {
          success: false,
          message: "Expected array, but was " + (xs === null ? xs : typeof xs)
        };
      }

      for (var _i = 0, xs_1 = xs; _i < xs_1.length; _i++) {
        var x = xs_1[_i];
        var validated = runtype.innerValidate(element, x, visited);

        if (!validated.success) {
          return {
            success: false,
            message: validated.message,
            key: validated.key ? "[" + xs.indexOf(x) + "]." + validated.key : "[" + xs.indexOf(x) + "]"
          };
        }
      }

      return {
        success: true,
        value: xs
      };
    }, {
      tag: 'array',
      isReadonly: isReadonly,
      element: element
    }));
  }

  function Arr(element) {
    return InternalArr(element, false);
  }

  exports.Array = Arr;

  function withExtraModifierFuncs(A) {
    A.asReadonly = asReadonly;
    return A;

    function asReadonly() {
      return InternalArr(A.element, true);
    }
  }
});
unwrapExports(array);
var array_1 = array.Array;
var tuple = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Tuple() {
    var components = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      components[_i] = arguments[_i];
    }

    return runtype.create(function (x, visited) {
      var validated = runtype.innerValidate(array.Array(unknown.Unknown), x, visited);

      if (!validated.success) {
        return {
          success: false,
          message: "Expected tuple to be an array:\xA0" + validated.message,
          key: validated.key
        };
      }

      if (validated.value.length !== components.length) {
        return {
          success: false,
          message: "Expected an array of length " + components.length + ", but was " + validated.value.length
        };
      }

      for (var i = 0; i < components.length; i++) {
        var validatedComponent = runtype.innerValidate(components[i], validated.value[i], visited);

        if (!validatedComponent.success) {
          return {
            success: false,
            message: validatedComponent.message,
            key: validatedComponent.key ? "[" + i + "]." + validatedComponent.key : "[" + i + "]"
          };
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'tuple',
      components: components
    });
  }

  exports.Tuple = Tuple;
});
unwrapExports(tuple);
var tuple_1 = tuple.Tuple;
var util = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // Type guard to determine if an object has a given key
  // If this feature gets implemented, we can use `in` instead: https://github.com/Microsoft/TypeScript/issues/10485

  function hasKey(k, o) {
    return typeof o === 'object' && k in o;
  }

  exports.hasKey = hasKey;
});
unwrapExports(util);
var util_1 = util.hasKey;
var record = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a record runtype from runtypes for its values.
   */

  function InternalRecord(fields, isPartial, isReadonly) {
    return withExtraModifierFuncs(runtype.create(function (x, visited) {
      if (x === null || x === undefined) {
        var a = runtype.create(function (_x) {
          return {
            success: true,
            value: _x
          };
        }, {
          tag: 'record',
          fields: fields
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a) + ", but was " + x
        };
      }

      for (var key in fields) {
        if (!isPartial || util.hasKey(key, x) && x[key] !== undefined) {
          var value = isPartial || util.hasKey(key, x) ? x[key] : undefined;
          var validated = runtype.innerValidate(fields[key], value, visited);

          if (!validated.success) {
            return {
              success: false,
              message: validated.message,
              key: validated.key ? key + "." + validated.key : key
            };
          }
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'record',
      isPartial: isPartial,
      isReadonly: isReadonly,
      fields: fields
    }));
  }

  exports.InternalRecord = InternalRecord;

  function Record(fields) {
    return InternalRecord(fields, false, false);
  }

  exports.Record = Record;

  function Partial(fields) {
    return InternalRecord(fields, true, false);
  }

  exports.Partial = Partial;

  function withExtraModifierFuncs(A) {
    A.asPartial = asPartial;
    A.asReadonly = asReadonly;
    return A;

    function asPartial() {
      return InternalRecord(A.fields, true, A.isReadonly);
    }

    function asReadonly() {
      return InternalRecord(A.fields, A.isPartial, true);
    }
  }
});
unwrapExports(record);
var record_1 = record.InternalRecord;
var record_2 = record.Record;
var record_3 = record.Partial;
var dictionary = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Dictionary(value, key) {
    if (key === void 0) {
      key = 'string';
    }

    return runtype.create(function (x, visited) {
      if (x === null || x === undefined) {
        var a = runtype.create(x, {
          tag: 'dictionary',
          key: key,
          value: value
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a) + ", but was " + x
        };
      }

      if (typeof x !== 'object') {
        var a = runtype.create(x, {
          tag: 'dictionary',
          key: key,
          value: value
        });
        return {
          success: false,
          message: "Expected " + show_1.default(a.reflect) + ", but was " + typeof x
        };
      }

      if (Object.getPrototypeOf(x) !== Object.prototype) {
        if (!Array.isArray(x)) {
          var a = runtype.create(x, {
            tag: 'dictionary',
            key: key,
            value: value
          });
          return {
            success: false,
            message: "Expected " + show_1.default(a.reflect) + ", but was " + Object.getPrototypeOf(x)
          };
        } else if (key === 'string') return {
          success: false,
          message: 'Expected dictionary, but was array'
        };
      }

      for (var k in x) {
        // Object keys are unknown strings
        if (key === 'number') {
          if (isNaN(+k)) return {
            success: false,
            message: 'Expected dictionary key to be a number, but was string'
          };
        }

        var validated = runtype.innerValidate(value, x[k], visited);

        if (!validated.success) {
          return {
            success: false,
            message: validated.message,
            key: validated.key ? k + "." + validated.key : k
          };
        }
      }

      return {
        success: true,
        value: x
      };
    }, {
      tag: 'dictionary',
      key: key,
      value: value
    });
  }

  exports.Dictionary = Dictionary;
});
unwrapExports(dictionary);
var dictionary_1 = dictionary.Dictionary;
var union = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Union() {
    var alternatives = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      alternatives[_i] = arguments[_i];
    }

    var match = function match() {
      var cases = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        cases[_i] = arguments[_i];
      }

      return function (x) {
        for (var i = 0; i < alternatives.length; i++) {
          if (alternatives[i].guard(x)) {
            return cases[i](x);
          }
        }
      };
    };

    return runtype.create(function (value, visited) {
      var commonLiteralFields = {};

      for (var _i = 0, alternatives_1 = alternatives; _i < alternatives_1.length; _i++) {
        var alternative = alternatives_1[_i];

        if (alternative.reflect.tag === 'record') {
          var _loop_1 = function _loop_1(fieldName) {
            var field = alternative.reflect.fields[fieldName];

            if (field.tag === 'literal') {
              if (commonLiteralFields[fieldName]) {
                if (commonLiteralFields[fieldName].every(function (value) {
                  return value !== field.value;
                })) {
                  commonLiteralFields[fieldName].push(field.value);
                }
              } else {
                commonLiteralFields[fieldName] = [field.value];
              }
            }
          };

          for (var fieldName in alternative.reflect.fields) {
            _loop_1(fieldName);
          }
        }
      }

      for (var fieldName in commonLiteralFields) {
        if (commonLiteralFields[fieldName].length === alternatives.length) {
          for (var _a = 0, alternatives_2 = alternatives; _a < alternatives_2.length; _a++) {
            var alternative = alternatives_2[_a];

            if (alternative.reflect.tag === 'record') {
              var field = alternative.reflect.fields[fieldName];

              if (field.tag === 'literal' && util.hasKey(fieldName, value) && value[fieldName] === field.value) {
                return runtype.innerValidate(alternative, value, visited);
              }
            }
          }
        }
      }

      for (var _b = 0, alternatives_3 = alternatives; _b < alternatives_3.length; _b++) {
        var targetType = alternatives_3[_b];

        if (runtype.innerValidate(targetType, value, visited).success) {
          return {
            success: true,
            value: value
          };
        }
      }

      var a = runtype.create(value, {
        tag: 'union',
        alternatives: alternatives
      });
      return {
        success: false,
        message: "Expected " + show_1.default(a) + ", but was " + (value === null ? value : typeof value)
      };
    }, {
      tag: 'union',
      alternatives: alternatives,
      match: match
    });
  }

  exports.Union = Union;
});
unwrapExports(union);
var union_1 = union.Union;
var intersect = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Intersect() {
    var intersectees = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      intersectees[_i] = arguments[_i];
    }

    return runtype.create(function (value, visited) {
      for (var _i = 0, intersectees_1 = intersectees; _i < intersectees_1.length; _i++) {
        var targetType = intersectees_1[_i];
        var validated = runtype.innerValidate(targetType, value, visited);

        if (!validated.success) {
          return validated;
        }
      }

      return {
        success: true,
        value: value
      };
    }, {
      tag: 'intersect',
      intersectees: intersectees
    });
  }

  exports.Intersect = Intersect;
});
unwrapExports(intersect);
var intersect_1 = intersect.Intersect;

var _function = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a runtype for functions.
   */

  exports.Function = runtype.create(function (value) {
    return typeof value === 'function' ? {
      success: true,
      value: value
    } : {
      success: false,
      message: "Expected function, but was " + (value === null ? value : typeof value)
    };
  }, {
    tag: 'function'
  });
});

unwrapExports(_function);
var _function_1 = _function.Function;

var _instanceof = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function InstanceOf(ctor) {
    return runtype.create(function (value) {
      return value instanceof ctor ? {
        success: true,
        value: value
      } : {
        success: false,
        message: "Expected " + ctor.name + ", but was " + (value === null ? value : typeof value)
      };
    }, {
      tag: 'instanceof',
      ctor: ctor
    });
  }

  exports.InstanceOf = InstanceOf;
});

unwrapExports(_instanceof);
var _instanceof_1 = _instanceof.InstanceOf;
var lazy = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Construct a possibly-recursive Runtype.
   */

  function Lazy(delayed) {
    var data = {
      get tag() {
        return getWrapped()['tag'];
      }

    };
    var cached;

    function getWrapped() {
      if (!cached) {
        cached = delayed();

        for (var k in cached) {
          if (k !== 'tag') data[k] = cached[k];
        }
      }

      return cached;
    }

    return runtype.create(function (x) {
      return getWrapped().validate(x);
    }, data);
  }

  exports.Lazy = Lazy;
});
unwrapExports(lazy);
var lazy_1 = lazy.Lazy;
var constraint = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function Constraint(underlying, constraint, options) {
    return runtype.create(function (value) {
      var name = options && options.name;
      var validated = underlying.validate(value);

      if (!validated.success) {
        return validated;
      }

      var result = constraint(validated.value);
      if (string.String.guard(result)) return {
        success: false,
        message: result
      };else if (!result) return {
        success: false,
        message: "Failed " + (name || 'constraint') + " check"
      };
      return {
        success: true,
        value: validated.value
      };
    }, {
      tag: 'constraint',
      underlying: underlying,
      constraint: constraint,
      name: options && options.name,
      args: options && options.args
    });
  }

  exports.Constraint = Constraint;

  exports.Guard = function (guard, options) {
    return unknown.Unknown.withGuard(guard, options);
  };
});
unwrapExports(constraint);
var constraint_1 = constraint.Constraint;
var constraint_2 = constraint.Guard;
var brand = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.RuntypeName = Symbol('RuntypeName');

  function Brand(brand, entity) {
    return runtype.create(function (value) {
      var validated = entity.validate(value);
      return validated.success ? {
        success: true,
        value: validated.value
      } : validated;
    }, {
      tag: 'brand',
      brand: brand,
      entity: entity
    });
  }

  exports.Brand = Brand;
});
unwrapExports(brand);
var brand_1 = brand.RuntypeName;
var brand_2 = brand.Brand;
var decorator = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var prototypes = new WeakMap();
  /**
   * A parameter decorator. Explicitly mark the parameter as checked on every method call in combination with `@checked` method decorator. The number of `@check` params must be the same as the number of provided runtypes into `@checked`.\
   * Usage:
   * ```ts
   * @checked(Runtype1, Runtype3)
   * method(@check p1: Static1, p2: number, @check p3: Static3) { ... }
   * ```
   */

  function check(target, propertyKey, parameterIndex) {
    var prototype = prototypes.get(target) || new Map();
    prototypes.set(target, prototype);
    var validParameterIndices = prototype.get(propertyKey) || [];
    prototype.set(propertyKey, validParameterIndices);
    validParameterIndices.push(parameterIndex);
  }

  exports.check = check;

  function getValidParameterIndices(target, propertyKey, runtypeCount) {
    var prototype = prototypes.get(target);
    var validParameterIndices = prototype && prototype.get(propertyKey);

    if (validParameterIndices) {
      // used with `@check` parameter decorator
      return validParameterIndices;
    }

    var indices = [];

    for (var i = 0; i < runtypeCount; i++) {
      indices.push(i);
    }

    return indices;
  }
  /**
   * A method decorator. Takes runtypes as arguments which correspond to the ones of the actual method.
   *
   * Usually, the number of provided runtypes must be _**the same as**_ or _**less than**_ the actual parameters.
   *
   * If you explicitly mark which parameter shall be checked using `@check` parameter decorator, the number of `@check` parameters must be _**the same as**_ the runtypes provided into `@checked`.
   *
   * Usage:
   * ```ts
   * @checked(Runtype1, Runtype2)
   * method1(param1: Static1, param2: Static2, param3: any) {
   *   ...
   * }
   *
   * @checked(Runtype1, Runtype3)
   * method2(@check param1: Static1, param2: any, @check param3: Static3) {
   *   ...
   * }
   * ```
   */


  function checked() {
    var runtypes = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      runtypes[_i] = arguments[_i];
    }

    if (runtypes.length === 0) {
      throw new Error('No runtype provided to `@checked`. Please remove the decorator.');
    }

    return function (target, propertyKey, descriptor) {
      var method = descriptor.value;
      var methodId = (target.name || target.constructor.name + '.prototype') + (typeof propertyKey === 'string' ? "[\"" + propertyKey + "\"]" : "[" + String(propertyKey) + "]");
      var validParameterIndices = getValidParameterIndices(target, propertyKey, runtypes.length);

      if (validParameterIndices.length !== runtypes.length) {
        throw new Error('Number of `@checked` runtypes and @check parameters not matched.');
      }

      if (validParameterIndices.length > method.length) {
        throw new Error('Number of `@checked` runtypes exceeds actual parameter length.');
      }

      descriptor.value = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        runtypes.forEach(function (type, typeIndex) {
          var parameterIndex = validParameterIndices[typeIndex];
          var validated = type.validate(args[parameterIndex]);

          if (!validated.success) {
            throw new errors.ValidationError(methodId + ", argument #" + parameterIndex + ": " + validated.message, validated.key);
          }
        });
        return method.apply(this, args);
      };
    };
  }

  exports.checked = checked;
});
unwrapExports(decorator);
var decorator_1 = decorator.check;
var decorator_2 = decorator.checked;
var lib = createCommonjsModule(function (module, exports) {
  function __export(m) {
    for (var p in m) {
      if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __export(contract);

  __export(asynccontract);

  __export(match_1);

  __export(errors);

  __export(unknown);

  __export(never);

  __export(_void);

  exports.Literal = literal_1.Literal;
  exports.Undefined = literal_1.Undefined;
  exports.Null = literal_1.Null;

  __export(boolean_1);

  __export(number);

  __export(string);

  __export(symbol);

  __export(array);

  __export(tuple);

  __export(record);

  __export(dictionary);

  __export(union);

  __export(intersect);

  __export(_function);

  exports.InstanceOf = _instanceof.InstanceOf;

  __export(lazy);

  __export(constraint);

  exports.Brand = brand.Brand;

  __export(decorator);
});
unwrapExports(lib);
var lib_1 = lib.Record;
var lib_2 = lib.Partial;
var lib_3 = lib.Number;
var lib_4 = lib.String;
var lib_5 = lib.Array;
var lib_6 = lib.Static;
var lib_7 = lib.Union;
var lib_8 = lib.Unknown;
var lib_9 = lib.Boolean;
var lib_10 = lib.Literal;
var lib_11 = lib.Undefined;
var lib_12 = lib.Null;
var lib_13 = lib.InstanceOf;
var lib_14 = lib.Brand;
var index_cjs = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  var PingMessage = lib.Record({
    type: lib.Literal("ping"),
    nonce: lib.Number
  });
  var PongMessage = lib.Record({
    type: lib.Literal("pong"),
    nonce: lib.Number
  });
  var PingPongMessages = lib.Union(PingMessage, PongMessage);
  var PingPongOptions = lib.Partial({
    interval: lib.Number,
    timeout: lib.Number,
    verbose: lib.Boolean
  });
  var pingPongDefaultOptions = {
    interval: 8000,
    timeout: 1000,
    verbose: false
  };

  function PongWS(ws) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _pingPongDefaultOptio = _objectSpread(_objectSpread({}, pingPongDefaultOptions), o),
        interval = _pingPongDefaultOptio.interval,
        timeout = _pingPongDefaultOptio.timeout,
        verbose = _pingPongDefaultOptio.verbose;

    var pongTimer;
    var nonce;
    var pongTimeout;

    function startPongTimer() {
      pongTimer = setInterval(function () {
        if (pongTimeout) {
          clearTimeout(pongTimeout);
        }

        nonce = Math.floor(Math.random() * 1024 * 1024);

        if (verbose) {
          console.log("-> pong ".concat(nonce));
        }

        ws.send(JSON.stringify(PongMessage.check({
          type: "pong",
          nonce: nonce
        })));
        pongTimeout = setTimeout(function () {
          ws.close();
        }, timeout);
      }, interval);
    }

    if (ws.readyState === ws.OPEN) {
      startPongTimer();
    } else {
      ws.addEventListener("open", startPongTimer);
    }

    ws.addEventListener("message", function (_ref) {
      var data = _ref.data;
      var message = JSON.parse(data);

      if (PongMessage.guard(message) && message.nonce === nonce && pongTimeout) {
        if (verbose) {
          console.log("<- pong ".concat(nonce));
        }

        clearTimeout(pongTimeout);
      } else if (PingMessage.guard(message)) {
        ws.send(data);
      }
    });
    ws.addEventListener("close", function () {
      if (pongTimer) {
        clearInterval(pongTimer);
      }

      if (pongTimeout) {
        clearTimeout(pongTimeout);
      }
    });
    return ws;
  }

  function PingWS(ws) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _pingPongDefaultOptio2 = _objectSpread(_objectSpread({}, pingPongDefaultOptions), o),
        interval = _pingPongDefaultOptio2.interval,
        timeout = _pingPongDefaultOptio2.timeout,
        verbose = _pingPongDefaultOptio2.verbose;

    var pingTimer;
    var nonce;
    var pingTimeout;

    function startPingTimer() {
      pingTimer = setInterval(function () {
        if (pingTimeout) {
          clearTimeout(pingTimeout);
        }

        nonce = Math.floor(Math.random() * 1024 * 1024);

        if (verbose) {
          console.log("-> ping ".concat(nonce));
        }

        ws.send(JSON.stringify(PingMessage.check({
          type: "ping",
          nonce: nonce
        })));
        pingTimeout = setTimeout(function () {
          ws.close();
        }, timeout);
      }, interval);
    }

    if (ws.readyState === ws.OPEN) {
      startPingTimer();
    } else {
      ws.addEventListener("open", startPingTimer);
    }

    ws.addEventListener("message", function (_ref2) {
      var data = _ref2.data;
      var message = JSON.parse(data);

      if (PingMessage.guard(message) && message.nonce === nonce && pingTimeout) {
        if (verbose) {
          console.log("<- ping ".concat(nonce));
        }

        clearTimeout(pingTimeout);
      } else if (PongMessage.guard(message)) {
        ws.send(data);
      }
    });
    ws.addEventListener("close", function () {
      if (pingTimer) {
        clearInterval(pingTimer);
      }

      if (pingTimeout) {
        clearTimeout(pingTimeout);
      }
    });
    return ws;
  }

  function filterPingPongMessages(listener) {
    return function (event) {
      try {
        var message = JSON.parse(event.data);

        if (PingPongMessages.guard(message)) {
          return;
        }
      } catch (err) {}

      return listener(event);
    };
  }

  exports.PingPongMessages = PingPongMessages;
  exports.PingPongOptions = PingPongOptions;
  exports.PingWS = PingWS;
  exports.PongWS = PongWS;
  exports.filterPingPongMessages = filterPingPongMessages;
  exports.pingPongDefaultOptions = pingPongDefaultOptions;
});
unwrapExports(index_cjs);
var index_cjs_1 = index_cjs.PingPongMessages;
var index_cjs_2 = index_cjs.PingPongOptions;
var index_cjs_3 = index_cjs.PingWS;
var index_cjs_4 = index_cjs.PongWS;
var index_cjs_5 = index_cjs.filterPingPongMessages;
var index_cjs_6 = index_cjs.pingPongDefaultOptions; // Copyright Joyent, Inc. and other Node contributors.

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;

if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}

var events = EventEmitter;
var once_1 = once; // Backwards-compat with node 0.10.x

EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.

var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }

    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function () {
  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.


EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }

  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];

  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }

  var doError = type === 'error';
  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false; // If there is no 'error' event listener then throw.

  if (doError) {
    var er;
    if (args.length > 0) er = args[0];

    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    } // At least give some kind of context to the user


    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];
  if (handler === undefined) return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  checkListener(listener);
  events = target._events;

  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object

      events = target._events;
    }

    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener]; // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    } // Check for listener leak


    m = _getMaxListeners(target);

    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true; // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax

      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0) return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = {
    fired: false,
    wrapFn: undefined,
    target: target,
    type: type,
    listener: listener
  };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
}; // Emits a 'removeListener' event if and only if the listener was removed.


EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  checkListener(listener);
  events = this._events;
  if (events === undefined) return this;
  list = events[type];
  if (list === undefined) return this;

  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;
    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }
    if (list.length === 1) events[type] = list[0];
    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;
  events = this._events;
  if (events === undefined) return this; // not listening for removeListener, no need to emit

  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }

    return this;
  } // emit removeListener for all listeners on all events


  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;

    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }

    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }

  return this;
};

function _listeners(target, type, unwrap) {
  var events = target._events;
  if (events === undefined) return [];
  var evlistener = events[type];
  if (evlistener === undefined) return [];
  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;

function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);

  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }

  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }

  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);

  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }

  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function eventListener() {
      if (errorListener !== undefined) {
        emitter.removeListener('error', errorListener);
      }

      resolve([].slice.call(arguments));
    }

    var errorListener; // Adding an error listener is not optional because
    // if an error is thrown on an event emitter we cannot
    // guarantee that the actual event we are waiting will
    // be fired. The result could be a silent way to create
    // memory or file descriptor leaks, which is something
    // we should avoid.

    if (name !== 'error') {
      errorListener = function errorListener(err) {
        emitter.removeListener(name, eventListener);
        reject(err);
      };

      emitter.once('error', errorListener);
    }

    emitter.once(name, eventListener);
  });
}

var events_1 = events.EventEmitter;
events.once = once_1; // Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.

var getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);

function rng() {
  if (!getRandomValues) {
    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
  }

  return getRandomValues(rnds8);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */


var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function bytesToUuid(buf, offset_) {
  var offset = offset_ || 0; // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

  return (byteToHex[buf[offset + 0]] + byteToHex[buf[offset + 1]] + byteToHex[buf[offset + 2]] + byteToHex[buf[offset + 3]] + '-' + byteToHex[buf[offset + 4]] + byteToHex[buf[offset + 5]] + '-' + byteToHex[buf[offset + 6]] + byteToHex[buf[offset + 7]] + '-' + byteToHex[buf[offset + 8]] + byteToHex[buf[offset + 9]] + '-' + byteToHex[buf[offset + 10]] + byteToHex[buf[offset + 11]] + byteToHex[buf[offset + 12]] + byteToHex[buf[offset + 13]] + byteToHex[buf[offset + 14]] + byteToHex[buf[offset + 15]]).toLowerCase();
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return bytesToUuid(rnds);
}

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return decodeURIComponent(components.join(''));
  } catch (err) {// Do nothing
  }

  if (components.length === 1) {
    return components;
  }

  split = split || 1; // Split the array in 2 parts

  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher);

    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher);
    }

    return input;
  }
}

function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher.exec(input);

  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);

      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }

    match = multiMatcher.exec(input);
  } // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else


  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);

  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }

  return input;
}

var decodeUriComponent = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }

  try {
    encodedURI = encodedURI.replace(/\+/g, ' '); // Try the built in decoder first

    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }

  if (separator === '') {
    return [string];
  }

  var separatorIndex = string.indexOf(separator);

  if (separatorIndex === -1) {
    return [string];
  }

  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var queryString = createCommonjsModule(function (module, exports) {
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };

  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;

            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[', index, ']'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };

      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[]'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };

      case 'comma':
      case 'separator':
        return function (key) {
          return function (result, value) {
            if (value === null || value === undefined || value.length === 0) {
              return result;
            }

            if (result.length === 0) {
              return [[encode(key, options), '=', encode(value, options)].join('')];
            }

            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        };

      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [encode(key, options)]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }

  function parserForArrayFormat(options) {
    var result;

    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }

          accumulator[key][result[1]] = value;
        };

      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };

      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.split('').indexOf(options.arrayFormatSeparator) > -1;
          var newValue = isArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };

      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }

  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }

  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }

    return value;
  }

  function decode(value, options) {
    if (options.decode) {
      return decodeUriComponent(value);
    }

    return value;
  }

  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }

    if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }

    return input;
  }

  function removeHash(input) {
    var hashStart = input.indexOf('#');

    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }

    return input;
  }

  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');

    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }

    return hash;
  }

  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');

    if (queryStart === -1) {
      return '';
    }

    return input.slice(queryStart + 1);
  }

  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }

    return value;
  }

  function parse(input, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options); // Create an object with no prototype

    var ret = Object.create(null);

    if (typeof input !== 'string') {
      return ret;
    }

    input = input.trim().replace(/^[?#&]/, '');

    if (!input) {
      return ret;
    }

    var _iterator = _createForOfIteratorHelper(input.split('&')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;

        var _splitOnFirst = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='),
            _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
            _key = _splitOnFirst2[0],
            _value = _splitOnFirst2[1]; // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters


        _value = _value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    for (var _i2 = 0, _Object$keys = Object.keys(ret); _i2 < _Object$keys.length; _i2++) {
      var key = _Object$keys[_i2];
      var value = ret[key];

      if (typeof value === 'object' && value !== null) {
        for (var _i3 = 0, _Object$keys2 = Object.keys(value); _i3 < _Object$keys2.length; _i3++) {
          var k = _Object$keys2[_i3];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }

    if (options.sort === false) {
      return ret;
    }

    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];

      if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }

      return result;
    }, Object.create(null));
  }

  exports.extract = extract;
  exports.parse = parse;

  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }

    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);

    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };

    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};

    for (var _i4 = 0, _Object$keys3 = Object.keys(object); _i4 < _Object$keys3.length; _i4++) {
      var key = _Object$keys3[_i4];

      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }

    var keys = Object.keys(objectCopy);

    if (options.sort !== false) {
      keys.sort(options.sort);
    }

    return keys.map(function (key) {
      var value = object[key];

      if (value === undefined) {
        return '';
      }

      if (value === null) {
        return encode(key, options);
      }

      if (Array.isArray(value)) {
        return value.reduce(formatter(key), []).join('&');
      }

      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };

  exports.parseUrl = function (input, options) {
    options = Object.assign({
      decode: true
    }, options);

    var _splitOnFirst3 = splitOnFirst(input, '#'),
        _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
        url = _splitOnFirst4[0],
        hash = _splitOnFirst4[1];

    return Object.assign({
      url: url.split('?')[0] || '',
      query: parse(extract(input), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };

  exports.stringifyUrl = function (input, options) {
    options = Object.assign({
      encode: true,
      strict: true
    }, options);
    var url = removeHash(input.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(input.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, input.query);
    var queryString = exports.stringify(query, options);

    if (queryString) {
      queryString = "?".concat(queryString);
    }

    var hash = getHash(input.url);

    if (input.fragmentIdentifier) {
      hash = "#".concat(encode(input.fragmentIdentifier, options));
    }

    return "".concat(url).concat(queryString).concat(hash);
  };
});
var queryString_1 = queryString.extract;
var queryString_2 = queryString.parse;
var queryString_3 = queryString.stringify;
var queryString_4 = queryString.parseUrl;
var queryString_5 = queryString.stringifyUrl; // Combined versions and commits, assembled on the server

var Versions = lib_1({
  commit: lib_1({
    client: lib_4,
    server: lib_4
  }),
  version: lib_1({
    client: lib_4,
    server: lib_4
  })
}); // Type for the query parameters included in the initial websocket connection
// TODO: require googleToken, since we don't need to support anonymous connections
// (even if we support anonymous messaging...)

var ConnectionQuery = lib_1({
  client: lib_4,
  version: lib_4,
  commit: lib_4,
  googleToken: lib_4
}); // Message types: all must have a distinct type field
// It's usually best to keep client -> server messages distinct from
// server -> messages, even if they have the same data shape.

var ChitterContents = lib_1({
  id: lib_4,
  view: lib_4,
  room: lib_4,
  messageType: lib_4,
  contents: lib_8
}); // client -> server: message to send to a room

var ChitterMessageRequestType = "messagerequest";
var ChitterMessageRequest = ChitterContents.And(lib_1({
  type: lib_10(ChitterMessageRequestType)
})).And( // Only set by the client during development
lib_2({
  email: lib_4,
  name: lib_4
})); // server -> client: original message with some fields added

var ChitterMessageType = "message";
var ChitterMessage = ChitterContents.And(lib_1({
  type: lib_10(ChitterMessageType),
  new: lib_9,
  timestamp: lib_7(lib_4, lib_13(Date)),
  unixtime: lib_3,
  email: lib_4,
  name: lib_4
})); // server -> database: add clientID field and override type

var SavedChitterMessage = ChitterMessage.And(lib_1({
  _id: lib_4,
  client: lib_4,
  versions: Versions
})); // client -> server: Request to join a room

var JoinRequestMessageType = "joinrequest";
var JoinRequestMessage = lib_1({
  type: lib_10(JoinRequestMessageType),
  id: lib_4,
  room: lib_4
}); // server -> client: room request response

var JoinResponseMessageType = "join";
var JoinResponseMessage = lib_1({
  type: lib_10(JoinResponseMessageType),
  id: lib_4,
  room: lib_7(lib_4, lib_10(false))
}); // client -> server: Request for room history
// Server responds with 0 or more ReceivedChitterMessages, and then a history response

var HistoryRequestMessageType = "historyrequest";
var HistoryRequestMessage = lib_1({
  type: lib_10(HistoryRequestMessageType),
  id: lib_4,
  room: lib_4,
  end: lib_4,
  count: lib_3
}); // server -> client: Final response to close room history request
// Server responds with 0 or more ReceivedChitterMessages, and then a history response

var HistoryResponseMessageType = "history";
var HistoryResponseMessage = lib_1({
  type: lib_10(HistoryResponseMessageType),
  id: lib_4,
  start: lib_4,
  end: lib_4,
  count: lib_3
}); // All messages that can be sent by the client

var ClientMessages = lib_7(ChitterMessageRequest, JoinRequestMessage, HistoryRequestMessage); // All messages that can be sent by the server

var ServerMessages = lib_7(ChitterMessage, JoinResponseMessage, HistoryResponseMessage);
var ServerStatus = lib_1({
  started: lib_4.withConstraint(function (s) {
    return Date.parse(s) !== NaN;
  }),
  version: lib_4,
  commit: lib_4,
  counts: lib_1({
    client: lib_3,
    send: lib_3,
    request: lib_3,
    join: lib_3
  }),
  googleClientIDs: lib_5(lib_4)
});
/* eslint-disable @typescript-eslint/no-unused-vars */

var VERSION = lib_4.check("2020.7.2");
var COMMIT = lib_4.check("d83ffc6");

var ChitterProvider = function ChitterProvider(_ref3) {
  var server = _ref3.server,
      googleToken = _ref3.googleToken,
      children = _ref3.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      connected = _useState2[0],
      setConnected = _useState2[1];

  var client = useRef(typeof window !== "undefined" && sessionStorage.getItem("chitter:id") || v4());
  var connection = useRef(undefined);
  var messager = useRef(new events_1());
  var joinRequests = useRef({});
  useEffect(function () {
    sessionStorage.setItem("chitter:id", client.current);
    return function () {
      var _a; // eslint-disable-next-line react-hooks/exhaustive-deps


      (_a = messager.current) === null || _a === void 0 ? void 0 : _a.removeAllListeners();
    };
  }, []);
  useEffect(function () {
    var _a;

    (_a = connection.current) === null || _a === void 0 ? void 0 : _a.close();

    if (!googleToken) {
      return;
    }

    var connectionQuery = ConnectionQuery.check({
      googleToken: googleToken,
      client: client.current,
      version: VERSION,
      commit: COMMIT
    });
    connection.current = index_cjs_3(new ReconnectingWebSocket("".concat(server, "?").concat(queryString.stringify(connectionQuery)), [], {
      startClosed: true
    }));
    connection.current.addEventListener("open", function () {
      return setConnected(true);
    });
    connection.current.addEventListener("close", function () {
      return setConnected(false);
    });
    connection.current.addEventListener("message", index_cjs_5(function (_ref4) {
      var data = _ref4.data;
      var response = JSON.parse(data);

      if (!ServerMessages.guard(response)) {
        console.error("Bad message: ".concat(JSON.stringify(response, null, 2)));
        return;
      }

      if (ChitterMessage.guard(response)) {
        messager.current.emit(response.room, response);
      } else if (JoinResponseMessage.guard(response)) {
        var id = response.id,
            room = response.room;
        var request = joinRequests.current[id];

        if (!request) {
          console.error("Mismatched join response");
          return;
        }

        var succeeded = room !== false;
        request.status = succeeded;
        request.onJoin(succeeded, succeeded ? undefined : new Error("Join request rejected"));
        succeeded && messager.current.addListener(room, request.onReceive);
      }
    }));
    connection.current.reconnect();
    return function () {
      var _a;

      (_a = connection.current) === null || _a === void 0 ? void 0 : _a.close();
    };
  }, [server, googleToken]);
  var join = useCallback(function (request) {
    var _a;

    var view = v4();
    joinRequests.current[view] = _objectSpread(_objectSpread({}, request), {}, {
      status: false
    });
    var room = request.room,
        sendOptions = request.sendOptions;
    (_a = connection.current) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(JoinRequestMessage.check({
      type: JoinRequestMessageType,
      id: view,
      room: room
    })));

    var send = function send(type, contents) {
      var _a;

      if (joinRequests.current[view].status !== true) {
        console.error("Can't send messages to room before joining");
        return undefined;
      }

      var id = v4();
      var message = ChitterMessageRequest.check(_objectSpread({
        type: ChitterMessageRequestType,
        id: id,
        view: view,
        room: room,
        messageType: type,
        contents: contents
      }, sendOptions));
      (_a = connection.current) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(message));
      return id;
    };

    var requestMessages = function requestMessages(end, count) {
      var _a;

      if (joinRequests.current[view].status !== true) {
        console.error("Can't request room history before joining");
        return;
      }

      var message = HistoryRequestMessage.check({
        type: HistoryRequestMessageType,
        id: v4(),
        room: room,
        end: end.toISOString(),
        count: count
      });
      (_a = connection.current) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(message));
    };

    var leave = function leave() {
      try {
        messager.current.removeListener(room, joinRequests.current[view].onReceive);
      } catch (err) {}

      delete joinRequests.current[view];
    };

    return {
      send: send,
      request: requestMessages,
      leave: leave
    };
  }, []);
  return React.createElement(ChitterContext.Provider, {
    value: {
      available: true,
      connected: connected,
      join: join
    }
  }, children);
};

var useChitter = function useChitter() {
  return useContext(ChitterContext);
}; // This is a default context object that we need to provide for some reason
// It should never be used by an actual subscriber
// Just set default values for fields and functions that throw for callbacks


var ChitterContext = createContext({
  available: false,
  connected: false,
  join: function join() {
    throw new Error("ChitterProvider not set");
  }
});
export { ChitterContext, ChitterMessageRequest as ChitterMessage, ChitterProvider, useChitter };